import * as React from 'react';
import { usePage } from '../hooks/usePage';
import KiteList from './KiteList';

export default function Menu() {
    const setPage = usePage();
    return (
        <div className="menu">
            <ul>
                <li className="menu__header">manage drafts</li>
            </ul>
            <KiteList />
            <ul>
                <li onClick={() => setPage('importExport')}>export/import</li>
            </ul>
        </div>
    );
}
